module.exports = __webpack_public_path__ + "static/media/sunday_times_footy2024.61d31fcc.webp";